var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "black",
    viewBox: "0 0 14 15",
    className: "transition-colors duration-300 fill-[#2E2E2E]",
    width: 14,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.903h.583a.583.583 0 0 0 0-1.166H5.25a.583.583 0 1 0 0 1.166zm0 1.167a.583.583 0 0 0 0 1.167h3.5a.583.583 0 1 0 0-1.167h-3.5zm6.416-1.785a.759.759 0 0 0-.035-.157v-.053a.622.622 0 0 0-.11-.163l-3.5-3.5a.624.624 0 0 0-.164-.111.187.187 0 0 0-.052 0 .513.513 0 0 0-.193-.064H4.083a1.75 1.75 0 0 0-1.75 1.75v8.166a1.75 1.75 0 0 0 1.75 1.75h5.833a1.75 1.75 0 0 0 1.75-1.75V5.285zm-3.5-2.059 1.511 1.51H8.75a.583.583 0 0 1-.584-.583v-.927zm2.334 7.927a.583.583 0 0 1-.584.584H4.083a.583.583 0 0 1-.583-.584V2.987a.583.583 0 0 1 .583-.584H7v1.75a1.75 1.75 0 0 0 1.75 1.75h1.75v5.25zm-1.75-1.75h-3.5a.583.583 0 1 0 0 1.167h3.5a.583.583 0 1 0 0-1.167z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.8809a01fa0d8ea340213be74c0860291.svg";
export { ForwardRef as ReactComponent };